import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import {
  Button,
  Icon,
  Loader,
  Modal,
  Pagination,
  TransitionablePortal,
} from "semantic-ui-react";
import EventCard from "../components/layout/EventCard";
import { deleteEventDoc } from "../store/actions/athleteActions";
import AddEvent from "./AddEvent";
import EditEvent from "./EditEvent";
import { getFilteredEvents } from "../utils/utils";
import EventsFilter from "../components/layout/EventsFilter";
const animation = "scale";
const duration = 500;
const Events = (props) => {
  const [totalPages, setTotalPages] = useState(1);
  const [activePage, setActivePage] = useState(1);
  const [data, setData] = useState([]);
  const [addEvent, setAddEvent] = useState(false);
  const [deleteEvent, setDeleteEvent] = useState(false);
  const [deleteEventId, setDeleteEventId] = useState(null);
  const [editEvent, setEditEvent] = useState(false);
  const [id, setId] = useState(null);
  const [name, setName] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [url, setUrl] = useState(null);
  const [advocate, setAdvocate] = useState(null);
  const [location, setLocation] = useState(null);
  const [sport, setSport] = useState(null);
  const [creator, setCreator] = useState(null);
  const [attenders, setAttenders] = useState(null);
  const [status, setStatus] = useState(null);
  const [search, setSearch] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    let todaysData = [...props.events];
    if (search && search.length > 0) {
      todaysData = todaysData.filter((event) => {
        return (
          event.eventName.toLowerCase().match(search) ||
          (event.eventLocation &&
            event.eventLocation.toLowerCase().match(search)) ||
          event.eventSport.toLowerCase().match(search)
        );
      });
    } else {
      todaysData = [...props.events];
    }
    const paginated =
      todaysData && todaysData.slice((activePage - 1) * 12, activePage * 12);
    setTotalPages(Math.ceil(todaysData.length / 12));
    setData(paginated);
  }, [props.events, activePage, search]);
  const handleSearch = (query) => {
    setSearch(query);
    // setActivePage(1);
  };
  const handleAddEventModal = () => {
    setAddEvent(!addEvent);
  };
  const handleAddEventClose = () => {
    setAddEvent(false);
  };
  const handleDelteEventModal = (id) => {
    setDeleteEventId(id);
    setDeleteEvent(!deleteEvent);
  };
  const handleEditEventClose = () => {
    setEditEvent(false);
  };
  const handleDelteEventClose = () => {
    setDeleteEvent(false);
  };
  const handleDeleteEvent = () => {
    dispatch(deleteEventDoc(deleteEventId));
    setDeleteEvent(false);
  };
  const handleEditEventOpen = (
    id,
    name,
    startDate,
    endDate,
    url,
    advocate,
    location,
    sport,
    creator,
    attenders,
    status
  ) => {
    setEditEvent(true);
    setId(id);
    setName(name);
    setStartDate(startDate);
    setEndDate(endDate);
    setUrl(url);
    setAdvocate(advocate);
    setLocation(location);
    setSport(sport);
    setCreator(creator);
    setAttenders(attenders);
    setStatus(status);
  };
  if (!props.auth.isLoaded) {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  } else if (
    props.auth.isLoaded &&
    (props.auth.email === "csanicknaudin@gmail.com" || props.superAdmin)
  ) {
    if (props.events) {
      const pageChange = (not, data) => {
        setActivePage(data.activePage);
      };
      return (
        <div className="AthleteDetailsBackground cu-profile">
          <div className="AthleteDetailsBannerBar"></div>
          <EventsFilter
            onChange={() => setActivePage(1)}
            superAdmin={true}
            searchQuery={handleSearch}
          />
          <div className="AthleteDetailsButtonContainer event-header">
            <div className="first-div"></div>
            <div className="second-div">
              <Button
                icon
                labelPosition="green"
                color="blue"
                onClick={handleAddEventModal}
              >
                <Icon name="calendar plus outline" />
                Add Event
              </Button>
            </div>
          </div>
          <div className="AthleteEventsInfoContainer common-event">
            {props.events && props.events.length < 1 && (
              <p className="not-found cu-center">There's No Data Right Now</p>
            )}
            <div
              className={`AthleteEventsGroupContainer ${
                data &&
                (data.length === 1
                  ? "onlyone"
                  : data.length === 2
                  ? "onlytwo"
                  : "")
              }`}
            >
              {data &&
                data.map((event) => (
                  <>
                    <EventCard
                      key={event.eventId}
                      eyShow={false}
                      id={event.eventId}
                      name={event.eventName}
                      startDate={
                        typeof event.eventStartDate !== "string"
                          ? event.eventStartDate.toDate().toDateString()
                          : event.eventStartDate
                      }
                      endDate={
                        typeof event.eventEndDate !== "string"
                          ? event.eventEndDate.toDate().toDateString()
                          : event.eventEndDate
                      }
                      url={event.eventUrl}
                      advocate={event.eventAdvocate}
                      location={event.eventLocation}
                      attendant={event.attenders}
                      visitors={event.eventAttenders}
                      status={event.eventStatus}
                      sport={event.eventSport}
                      deleteEvent={(id) => handleDelteEventModal(id)}
                      superAdmin={props.superAdmin}
                      creator={event.eventCreator}
                      editEvent={() =>
                        handleEditEventOpen(
                          event.eventId,
                          event.eventName,
                          typeof event.eventStartDate !== "string"
                            ? event.eventStartDate.toDate().toDateString()
                            : event.eventStartDate,
                          typeof event.eventEndDate !== "string"
                            ? event.eventEndDate.toDate().toDateString()
                            : event.eventEndDate,
                          event.eventUrl,
                          event.eventAdvocate,
                          event.eventLocation,
                          event.eventSport,
                          event.eventCreator,
                          event.eventAttenders,
                          event.eventStatus
                        )
                      }
                    />
                  </>
                ))}
            </div>
          </div>
          {/* pagination and pages show */}
          <div className="AthleteSearchDetail AthletePagination justify-center">
            <Pagination
              onPageChange={pageChange}
              defaultActivePage={1}
              firstItem={null}
              lastItem={null}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{
                content: <Icon name="angle right" />,
                icon: true,
              }}
              pointing
              secondary
              totalPages={totalPages}
            />
          </div>
          <TransitionablePortal
            transition={{ animation, duration }}
            open={deleteEvent}
            onClose={handleDelteEventClose}
          >
            <Modal
              className="delete-popup"
              onClose={handleDelteEventClose}
              open={true}
            >
              <Modal.Content>
                <p className="p1">Are you sure want to delete this record?</p>
                <p className="p2">This process cannot be undone.</p>
                <div className="delete-modal-footer">
                  <Button
                    name="closeButton"
                    content="Cancel"
                    onClick={handleDelteEventClose}
                  />
                  <Button
                    color="red"
                    name="saveButton"
                    content="Delete"
                    onClick={handleDeleteEvent}
                  />
                </div>
              </Modal.Content>
            </Modal>
          </TransitionablePortal>
          <AddEvent
            open={addEvent}
            role={props.role && props.role}
            close={handleAddEventClose}
          />
          <EditEvent
            open={editEvent}
            role={props.role && props.role}
            close={handleEditEventClose}
            id={id}
            name={name}
            startDate={startDate}
            endDate={endDate}
            url={url}
            advocate={advocate}
            location={location}
            creator={creator}
            attenders={attenders}
            sport={sport}
            status={status}
            superAdmin={props.superAdmin}
          />
        </div>
      );
    } else
      return (
        <div className="SpinnerBackground">
          <div className="SpinnerContainer">
            <Loader size="large" active inline="centered" />
          </div>
        </div>
      );
  } else if (props.auth.isLoaded && !props.auth.email) {
    return <Redirect to={`/login`} />;
  } else if (
    props.auth.isLoaded &&
    props.auth.email &&
    (props.auth.email !== "csanicknaudin@gmail.com" || !props.superAdmin)
  ) {
    return <Redirect to={`/events`} />;
  }
  return null;
};

const mapStateToProps = (state) => {
  let events = [];
  if (
    state.firestore.data.events &&
    state.firestore.data.athletes &&
    state.firestore.data.advocates
  ) {
    const keys = Object.keys(state.firestore.data.events);
    events = keys.map((key) => {
      let event =
        state.firestore.data.events[key] && state.firestore.data.events[key];
      if (event) {
        let attenders = event.eventAttenders;
        attenders = attenders.map((visitor) => {
          const person = {};
          if (visitor in state.firestore.data.athletes) {
            person.name =
              state.firestore.data.athletes[visitor].firstName +
              " " +
              state.firestore.data.athletes[visitor].lastName;
            person.image = state.firestore.data.athletes[visitor].thumbnail;
            person.id = visitor;
            person.customUrl = state.firestore.data.athletes[visitor].customUrl;
            person.extraData = state.firestore.data.athletes[visitor];
          } else if (visitor in state.firestore.data.advocates) {
            person.name = state.firestore.data.advocates[visitor].name;
            person.image = state.firestore.data.advocates[visitor].thumbnailUrl;
            person.id = visitor;
            person.customUrl =
              state.firestore.data.advocates[visitor].customUrl;
          }
          return person;
        });
        return { ...event, attenders };
      }
    });
  }
  events = events ? events.filter((event) => event) : [];

  events = events.sort(
    (date1, date2) => date2.eventStartDate - date1.eventStartDate
  );
  //  KEEP BELOW CODE COMMENTED 👇🏼
  // const dateToday = new Date();
  // const filteredEvents = events.filter((e) =>
  //   typeof e.eventEndDate !== "string"
  //     ? e.eventEndDate.toDate() >= dateToday
  //     : false
  // );
  // const filteredEvents2 = events.filter((e) =>
  //   typeof e.eventEndDate !== "string"
  //     ? e.eventEndDate.toDate() <= new Date()
  //     : false
  // );
  // const filteredEvents3 = events.filter(
  //   (e) => typeof e.eventEndDate === "string"
  // );
  // events = [...filteredEvents, ...filteredEvents3];
  //  KEEP ABOVE CODE COMMENTED 👆🏼
  return {
    events: events ? events.filter((event) => event) : [],
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    sport: state.athlete.superSport,
    date: state.athlete.superDate,
    creator: state.athlete.superCreator,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      getFilteredEvents(
        props.sport,
        props.creator,
        props.date,
        props.superAdmin
      ),
      {
        collection: "adminAthletes",
        storeAs: "athletes",
      },
      {
        collection: "advocates",
      },
    ];
    return firestoreArray;
  })
)(Events);
